module.exports = __webpack_public_path__ + "static/media/IR.7c8e6cb3.svg";